import { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { FanChoiceIcon } from "../components/FanChoiceIcon";
import api from "@/lib/api";
import SharedNavigation from "@/components/SharedNavigation";
import { Card } from "@/components/ui/card";
import { Countdown, Leaderboard } from "@/components/fanvote/FanVoteParts";
import { EnterPanel } from "@/components/fanvote/EnterPanel";

export default function FanVotePage() {
  const [me, setMe] = useState(null);
  const [data, setData] = useState(null);
  const [none, setNone] = useState(false);

  const load = useCallback(async () => {
    const { data: list } = await api.get("/fan-vote/rounds");
    const pick = list.rounds.find((r) => r.phase === "open") || list.rounds.find((r) => r.phase === "upcoming") || list.rounds[0];
    if (!pick) { setNone(true); return; }
    const { data: d } = await api.get(`/fan-vote/rounds/${pick.round_id}`);
    setData(d);
  }, []);
  useEffect(() => { load().catch(() => setNone(true)); api.get("/auth/me").then((r) => setMe(r.data)).catch(() => {}); }, [load]);
  useEffect(() => { const t = setInterval(() => load().catch(() => {}), 20000); return () => clearInterval(t); }, [load]);

  return (
    <div className="min-h-screen bg-[#08080c]">
      <Helmet><title>RGM Fan Vote</title></Helmet>
      <SharedNavigation currentUser={me} />
      <div className="max-w-4xl mx-auto pt-24 pb-20 px-4 sm:px-6 space-y-5" data-testid="fanvote-page">
        <div className="flex items-center gap-3"><FanChoiceIcon size="lg" testId="fanvote-title-icon" /><h1 className="text-4xl sm:text-5xl font-black text-white tracking-tight">RGM Fan Vote</h1></div>
        {none && !data && <p className="text-gray-400" data-testid="fanvote-no-round">No Fan Vote round is running right now. Check back soon.</p>}
        {data && (
          <>
            <Card className="bg-gradient-to-br from-purple-900/40 to-black border border-purple-500/30 p-6 space-y-2" data-testid="fanvote-round-card">
              <h2 className="text-2xl font-black text-white" data-testid="fanvote-round-title">{data.round.title}</h2>
              <Countdown round={data.round} />
              <p className="text-sm text-gray-300 whitespace-pre-line" data-testid="fanvote-rules">{data.round.rules}</p>
              <ul className="text-xs text-gray-400 space-y-0.5 pt-1">
                <li>· Free to vote, with no paid votes. One vote per verified RGM account per round.</li>
                <li>· Sign in with Google, or verify your email, to vote.</li>
                <li>· The song with the most valid votes when voting closes wins RGM Fan Choice.</li>
              </ul>
              <p className="text-xs text-gray-500" data-testid="fanvote-total-votes">{data.total_votes} {data.total_votes === 1 ? "vote" : "votes"} so far</p>
            </Card>
            <EnterPanel round={data.round} spotsLeft={data.spots_left} onEntered={load} />
            <Card className="bg-black/40 border border-white/10 p-5">
              <h3 className="text-white font-bold mb-2">{data.round.phase === "finalized" ? "Final results" : "Live leaderboard"}</h3>
              <Leaderboard entries={data.entries} roundId={data.round.round_id} />
            </Card>
          </>
        )}
      </div>
    </div>
  );
}
